// Все даты в приложении хранятся на сервере как настоящий UTC-момент (см. tenders.ts) —
// на клиенте их нужно форматировать в часовом поясе, который пользователь выбрал в
// настройках (users.timezone), а не жёстко в Europe/Moscow. utils/dateFormat.ts читает
// текущее значение через module-level переменную, обновляемую отсюда при каждом
// изменении user.value?.timezone (логин, обновление настроек, восстановление сессии).
export default defineNuxtPlugin(() => {
  const { user } = useAuth()

  watch(
    () => user.value?.timezone,
    (tz) => {
      if (tz) setDisplayTimezone(tz)
    },
    { immediate: true }
  )
})
